module.exports = __webpack_public_path__ + "img/orgao-atos-icon-min2.3bf6a65c.png";